<template>
  <AppDialog
    class="slack-ua-setup-nudge-modal"
    append-to-body
    size="medium"
    position="centered"
    title="New unusual activity detected"
    show
    data-qa="slack-ua-setup-nudge-modal"
    @close="$emit('close')"
  >
    <p class="slack-ua-setup-nudge-modal__subtitle">
      <strong>{{ membersLabel }}</strong> {{ wasWereLabel }} flagged for unusual activity.
      Don't want to keep checking back? 1-click connect to Slack and get these notifications in Slack.
    </p>
    <section class="slack-ua-setup-nudge-modal__message">
      <img
        class="slack-ua-setup-nudge-modal__logo"
        :src="slackLogo"
        alt=""
        width="36"
        height="36"
      >
      <div class="slack-ua-setup-nudge-modal__column">
        <div class="slack-ua-setup-nudge-modal__meta">
          Slack Alerts
          <span class="slack-ua-setup-nudge-modal__app-pill">APP</span>
        </div>
        <div class="slack-ua-setup-nudge-modal__attachment">
          <div class="slack-ua-setup-nudge-modal__detected-title">🚨 Unusual Activity Detected</div>
          <p class="slack-ua-setup-nudge-modal__summary">
            <strong>{{ membersLabel }}</strong> {{ wasWereLabel }} flagged for unusual activity in the past 7 days.
          </p>
          <ul
            v-if="nudge.members?.length"
            class="slack-ua-setup-nudge-modal__members"
          >
            <li
              v-for="member in nudge.members"
              :key="member.id"
              class="slack-ua-setup-nudge-modal__member"
            >
              <span class="slack-ua-setup-nudge-modal__pill-wrap">
                <span
                  class="slack-ua-setup-nudge-modal__type"
                  :class="`slack-ua-setup-nudge-modal__type--${member.type_key}`"
                >
                  {{ member.type_label }}
                </span>
              </span>
              <span class="slack-ua-setup-nudge-modal__description">{{ member.description }}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <div
      v-if="nudge.cta_kind !== 'disabled'"
      class="slack-ua-setup-nudge-modal__hint"
    >
      Connecting to Slack opens the integration setup in a new tab, where you'll authenticate your account.
    </div>
    <template #footer>
      <AppButton
        type="naked"
        class="slack-ua-setup-nudge-modal__dismiss"
        data-qa="slack-ua-setup-nudge-dont-show-again"
        @click="dismissModal"
      >
        Don't show again
      </AppButton>
      <SlackUaSetupNudgeCta
        source="Modal"
        :cta-kind="nudge.cta_kind"
        :connect-slack-url="nudge.connect_slack_url"
        @completed="$emit('completed')"
      />
    </template>
  </AppDialog>
</template>

<script>
import { mapGetters } from 'vuex';
import AppButton from '~/components/AppButton.vue';
import AppDialog from '~/components/AppDialog.vue';
import SlackUaSetupNudgeCta from '~/components/experiments/0229_slack_unusual_activity_setup/Cta.vue';
import { AR0229_LOGO_SLACK } from '~/rails_assets';
import { UserOrganizationsResource } from '~/resources';

export default {
  name: 'SlackUaSetupNudgeModal',
  components: {
    AppButton,
    AppDialog,
    SlackUaSetupNudgeCta,
  },
  emits: ['close', 'completed'],
  computed: {
    ...mapGetters(['organizationId', 'userOrganizationId', 'slackUaSetupNudge']),
    nudge() {
      return this.slackUaSetupNudge;
    },
    headlineCount() {
      return this.nudge.headline_count || 0;
    },
    membersLabel() {
      const count = this.headlineCount;

      return count === 1
        ? '1 member'
        : `${count} members`;
    },
    wasWereLabel() {
      return this.headlineCount === 1 ? 'was' : 'were';
    },
    slackLogo() {
      return AR0229_LOGO_SLACK;
    },
  },
  mounted() {
    window.analytics?.track('0229 Slack Setup Nudge Modal Viewed', {
      organization_id: this.organizationId,
      source: 'Unusual activity via Slack',
    });
  },
  methods: {
    async dismissModal() {
      try {
        const response = await UserOrganizationsResource.dismissDialog(
          { id: this.userOrganizationId },
          { dialog: this.nudge.dialog_key },
          { abortReload: true },
        );

        if (response?.errors) {
          this.$appMessage('Error dismissing dialog.');

          return;
        }

        this.$emit('close');
      } catch (error) {
        if (![401, 403].includes(error?.status)) {
          this.$appMessage('Unexpected error. Please try again.');
        }
      }
    },
  },
};
</script>
